import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { setOrder, initArticles, toggleArticlesView } from '../Actions/Search.action';
import CategoryItemViewer from '../Components/CategoryItemViewer';

const titleView = ({ title }) => !!title && title !== '' ? <h1 className="searchresult__sub-header">{title}</h1> : null;


const sorting = ({ sortRef, sortOrderOptions, setOrder }) => <div className="row">
    <div className="columns medium-3 medium-offset-9 custom-select-wrapper searchresult__sort-wrapper">
        <select className="custom-select"
            ref={sortRef}
            onChange={(event) => setOrder(event.target.value)}>
            {sortOrderOptions.map(({ order, text }) => <option key={order + text} value={order}>{text}</option>)}
        </select>
    </div>
</div>


const articleView = ({ categoryTitle, categoryUrl, image, title, url, introduction }) =>
    <div className="searchresult__article__item">
        {
            categoryTitle ? <a href={categoryUrl} className="searchresult__article__item-category">{categoryTitle}</a> : null
        }
        <h2 className="searchresult__article__item-title">
            <a href={url} className="searchresult__article__article-link">
                {title}
            </a>
        </h2>
        <div className="article__item-content">
            <div className="article__item-image">
                <img src={image} />
            </div>
            {
                introduction ? <div className="article__item-description" dangerouslySetInnerHTML={{ __html: introduction }} /> : null
            }
        </div>
    </div>

const showMore = (toggleArticle) => <div className='searchresult__show-more-link' onClick={toggleArticle}>Vis flere resultater</div>
const SearchPage = ({ articles, toggleArticle, storeSearchResult, articleSearchResultTitle, searchTerm, totalHits, setOrder, title, onlyStores, sortOrderOptions, categories, filter }) =>
    <>
        <div className='row'>
            <div className="columns small-12">
                <div className="hit-count">
                    <h2 className="hit-count__header">
                        "<span className="query">{searchTerm}</span>" ga {totalHits} treff totalt
                    </h2>
                </div>
                {articles && !onlyStores && articles.length > 0 ? <>
                    <h2 className="searchresult__aricle-header">
                        {articleSearchResultTitle}
                    </h2>
                    {sorting({ sortOrderOptions, setOrder })}
                    <div className="other-hits">
                        <ul className="other-hits__list-page row">
                            {articles ? articles.map((article, index) =>
                                <div key={index} className="column small-12 medium-6 large-4 ">
                                    {articleView(article)}
                                </div>
                            ) : null}
                        </ul>
                    </div>
                    {showMore(toggleArticle)}
                </> : null}
            </div>
            <div className="columns small-12">
                <div className="store__category-page">
                    {titleView({ title })}
                    <CategoryItemViewer {...{ storeSearchModel: { stores: storeSearchResult, categories }, groupsTitleOverride: 'Filtrer på kompetanse', filter: filter }} />
                </div>
            </div>
        </div>
    </>;

const SearchItemViewer = (params) => {
    const storeSearchResult = params.storeSearchResult && JSON.parse(params.storeSearchResult);
    const articleSearchResult = params.articleSearchResult && JSON.parse(params.articleSearchResult);
    const onlyStores = params.onlystores && JSON.parse(params.onlystores.toLowerCase());
    const totalHits = storeSearchResult ? storeSearchResult.length : 0 + articleSearchResult ? articleSearchResult.length : 0;
    const { setOrder, title, searchTerm, articleSearchResultTitle } = params;
    const categories = params.categories && JSON.parse(params.categories);
    const articles = params.displayedArticles;
    const filter = params.filter ? json.parse(params.filter) : null;

    const toggleArticle = () => params.toggleArticlesView();

    useEffect(() => {
        params.initArticles(articleSearchResult);
    }, []);

    const sortOrderOptions = [
        { order: 'NAME_ASC', text: 'Alfabetisk rekkefølge' },
        { order: 'NAME_DESC', text: 'i omvendt alfabetisk rekkefølge' }
    ]

    return SearchPage({ toggleArticle, articles, storeSearchResult, articleSearchResultTitle, totalHits, searchTerm, setOrder, title, onlyStores, sortOrderOptions, categories, 
        filter });
};

const mapDispatchToProps = dispatch => ({
    initArticles: (articles) => dispatch(initArticles(articles)),
    toggleArticlesView: () => dispatch(toggleArticlesView()),
    setOrder: (order) => dispatch(setOrder(order)),
});
const mapStateToProps = ({ search: { displayedArticles, currentStores, order, currentPage, displayedStores, searchString, filter } }) =>
    ({ displayedArticles, searchString, order, currentStores, currentPage, displayedStores, filter });
export default connect(mapStateToProps, mapDispatchToProps)(SearchItemViewer);